import React, { memo } from 'react';

import Content from '../../../../components/Content';
import Slider3D from '../../../../components/Slider3D';

import { Container, TitleContainer, ExclusiveContent } from './styles';

const ExclusiveSeries = ({ exclusiveLessons, showSpinner }) => {
  console.log(exclusiveLessons);
  return (
    <Container>
      <Content>
        <TitleContainer>
          <div>Kits de ensaio</div>
        </TitleContainer>
        <Slider3D
          route="podcast"
          lessons={exclusiveLessons}
          loading={showSpinner}
        />
      </Content>
    </Container>
  );
};

export default memo(ExclusiveSeries);
